import {
  COMPANYPROFILE_FETCHING,
  COMPANYPROFILE_FAILED,
  COMPANYPROFILE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case COMPANYPROFILE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case COMPANYPROFILE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case COMPANYPROFILE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
